/**
 * @generated SignedSource<<4350f6f38733e6aab960a02ee182da7f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueTableGroupByDropdown_GroupByDropdown_project$data = {
  readonly projectId?: string | null | undefined;
  readonly " $fragmentType": "ui_issueTableGroupByDropdown_GroupByDropdown_project";
};
export type ui_issueTableGroupByDropdown_GroupByDropdown_project$key = {
  readonly " $data"?: ui_issueTableGroupByDropdown_GroupByDropdown_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueTableGroupByDropdown_GroupByDropdown_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "ui_issueTableGroupByDropdown_GroupByDropdown_project",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "projectId"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "125a01c90cfe08a25751f38aeeeba424";

export default node;
